import * as THREE from 'three'
import { getParent, types, Instance } from 'mobx-state-tree'
import { generateNodeType } from 'src/api/models/utils/generateNodeType'
import { getReferencePoints2D } from 'src/utils/getReferencePoints'
import { ReferencePoints } from 'src/constants/referencePoints'
import { StringValue } from 'src/api/models/values'
import { IGenerateElementType, IElementName } from './types'

export const ElementName: IElementName = StringValue.views((self) => ({
  get placeholder() {
    const element = getParent(self) as Instance<
      ReturnType<typeof generateNodeType>
    >
    return element.__typename.split(/(?=[A-Z])/).join(' ')
  }
})).actions((self) => ({
  update(value?: string) {
    if (!!value && value !== self.value && value !== '') {
      self.value = value
    } else {
      self.value = self.placeholder
    }
  },
  afterAttach() {
    if (self.value === '') {
      // 2. Element // 1. Properties
      self.value = self.placeholder
    }
  }
}))

export const generateElementType: IGenerateElementType = (type) =>
  generateNodeType(type)
    .props({ name: types.optional(ElementName, { value: '' }) })
    .views((self) => ({
      getReferencePoints() {
        const x = (self as any).properties.width.value / 2
        const y = (self as any).properties.height.value / 2
        return getReferencePoints2D(
          new THREE.Box2(new THREE.Vector2(x, y), new THREE.Vector2(-x, -y))
        )
      }
    }))
    .views((self) => ({
      get referencePoints() {
        const referencePoints2D = self.getReferencePoints()
        return Object.entries(referencePoints2D).reduce(
          (p, [key, value]) => ({ ...p, [key]: [value[1], 0, value[0]] }),
          {} as ReferencePoints<[number, number, number]>
        )
      }
    }))
